import { inject, InjectionKey } from 'vue'

export function injectTyped<T>(key: InjectionKey<T>, fallback?: T) {
  const resolved = inject(key, fallback)
  if (!resolved) {
    console.error(`Could not resolve injection for ${key.description}`)
    throw new Error(`Could not resolve injection for ${key.description}`)
  }
  return resolved
}

export function provideEmptyMocks(keys: InjectionKey<any>[]): { [key: symbol]: any } {
  return keys.reduce(
    (config, key) => {
      config[key as unknown as symbol] = {}
      return config
    },
    {} as { [key: symbol]: any },
  )
}

export function createMockSVCs(services: [InjectionKey<any>, any][]) {
  return services.reduce(
    (acc, [key, service]) => {
      acc[key as symbol] = service
      return acc
    },
    {} as Record<symbol, any>,
  )
}
